(function () {

  function initPersonalizationControl() {
    const appOptions = document.querySelector('.po-productPageOptions-root')
                    || document.querySelector('.easify-product-options');
    const personalizationOption = document.querySelector(
      'se-option[data-name="Personalización"]'
    );

    if (!appOptions || !personalizationOption) return false;

    const savedValues = new Map();
    let updatePending = false;

    // Estilos base para la animación (se aplican una sola vez)
    appOptions.style.overflow = 'hidden';
    appOptions.style.transition = 'max-height 0.3s ease, opacity 0.2s ease';

    function isPersonalizedSelected() {
      const buttons = personalizationOption.querySelectorAll('.se-type-button');
      for (const button of buttons) {
        if (button.getAttribute('aria-checked') === 'true') {
          const label = button.querySelector('div');
          if (label && label.textContent.trim().includes('Personalizado')) return true;
        }
      }
      return false;
    }

    function saveFieldValue(field) {
      const key = field.name || field.id || field.dataset.key;
      if (!key) return;
      savedValues.set(key, field.type === 'checkbox' || field.type === 'radio'
        ? field.checked : field.value);
    }

    function restoreFieldValue(field) {
      const key = field.name || field.id || field.dataset.key;
      if (!key || !savedValues.has(key)) return;
      const saved = savedValues.get(key);
      if (field.type === 'checkbox' || field.type === 'radio') {
        field.checked = saved;
      } else {
        field.value = saved;
      }
    }

    function disablePersonalizationFields() {
      appOptions.querySelectorAll(
        'input:not([type="hidden"]), select, textarea, button'
      ).forEach(function (field) {
        if (!field.hasAttribute('data-original-disabled')) {
          field.setAttribute('data-original-disabled', field.disabled ? 'true' : 'false');
        }
        saveFieldValue(field);
        field.disabled = true;
        if (field.tagName === 'INPUT' && field.type === 'text') field.value = '';
        if (field.tagName === 'TEXTAREA') field.value = '';
        if (field.tagName === 'SELECT') field.selectedIndex = 0;
        if (field.type === 'radio' || field.type === 'checkbox') field.checked = false;
      });
      appOptions.querySelectorAll('input[type="hidden"]').forEach(function (field) {
        if (field.name && field.name.includes('properties[')) {
          saveFieldValue(field);
          field.value = '';
        }
      });
    }

    function enablePersonalizationFields() {
      appOptions.querySelectorAll(
        'input:not([type="hidden"]), select, textarea, button'
      ).forEach(function (field) {
        if (field.getAttribute('data-original-disabled') === 'false') {
          field.disabled = false;
        }
        field.removeAttribute('data-original-disabled');
        restoreFieldValue(field);
      });
      appOptions.querySelectorAll('input[type="hidden"]').forEach(function (field) {
        if (field.name && field.name.includes('properties[')) restoreFieldValue(field);
      });
      savedValues.clear();
    }

    function updatePersonalizationFields() {
      if (isPersonalizedSelected()) {
        // ✅ Medir altura real antes de animar
        appOptions.style.maxHeight = appOptions.scrollHeight + 'px';
        appOptions.style.opacity = '1';
        appOptions.style.pointerEvents = '';
        enablePersonalizationFields();
      } else {
        appOptions.style.maxHeight = '0';
        appOptions.style.opacity = '0';
        // ✅ Evitar clicks accidentales mientras está oculto
        appOptions.style.pointerEvents = 'none';
        disablePersonalizationFields();
      }
    }

    function scheduleUpdate() {
      if (updatePending) return;
      updatePending = true;
      setTimeout(function () {
        updatePersonalizationFields();
        updatePending = false;
      }, 50);
    }

    // ✅ Sin animación en la carga inicial para evitar flash
    appOptions.style.transition = 'none';
    updatePersonalizationFields();
    requestAnimationFrame(function () {
      appOptions.style.transition = 'max-height 0.3s ease, opacity 0.2s ease';
    });

    const observer = new MutationObserver(function (mutations) {
      if (mutations.some(m => m.type === 'attributes' && m.attributeName === 'aria-checked')) {
        scheduleUpdate();
      }
    });
    observer.observe(personalizationOption, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-checked'],
    });

    const domObserver = new MutationObserver(function () {
      if (!document.contains(personalizationOption)) {
        observer.disconnect();
        domObserver.disconnect();
      }
    });
    domObserver.observe(document.body, { childList: true, subtree: true });

    personalizationOption.addEventListener('click', function () {
      setTimeout(scheduleUpdate, 250);
    });

    return true;
  }

  function tryInit() {
    if (initPersonalizationControl()) return;
    let attempts = 0;
    const interval = setInterval(function () {
      attempts++;
      if (initPersonalizationControl() || attempts >= 40) clearInterval(interval);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }

})();
